import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/plan_uploads/PlanUploadsFlyout.scss';
import * as _ from 'lodash';
import CloseBigIcon from '../../assets/images/close-big-15x15.svg';
import { setNotification } from '../../redux/actions/general/notification';
import { __, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import Tooltip from '../../components/Tooltip';
import {
  deletePlanUploads,
  listPlanUploads,
  publishPlanUploads,
} from '../../redux/actions/table/plan_uploads';
import SendIcon from '../../assets/images/send-16x16.svg';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import classNames from 'classnames';
import Properties from './Properties';
import Files from './Files';
import { connect } from 'react-redux';
import OCRIcon from '../../assets/images/ocr-16x16.svg';
import ArrowDownMiddleIcon from '../../assets/images/arrow-down-middle-15x15.svg';
import { Element, ScrollLink, scrollSpy } from 'react-scroll';
import autobind from 'autobind-decorator';

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.plan_uploads/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(null, mapDispatchToProps)
@withRouter
class PlanUploadsFlyout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed_tabs: [],
      highlighted_tab: null,
      history_expanded: false,
    };

    this.highlight_timeout = null;

    this.tabs = ['properties', 'files'];

    this.tab_refs = [];
  }

  componentDidMount() {
    scrollSpy.update();

    if (this.props.tab_opened) {
      setTimeout(() => {
        this.tab_refs[this.props.tab_opened] &&
          this.tab_refs[this.props.tab_opened].click();

        setTableParams('plan_uploads', {
          tab: undefined,
        });
      }, 500);
    }
  }

  @autobind
  _toggleCollapseTab(tab) {
    this.setState({
      collapsed_tabs: _.xor(this.state.collapsed_tabs, [tab]),
    });
  }

  _highlightSection(section) {
    this.setState({ highlighted_tab: section }, () => {
      if (this.highlight_timeout) clearTimeout(this.highlight_timeout);

      this.highlight_timeout = setTimeout(() => {
        this.setState({ highlighted_tab: null });
      }, 200);
    });
  }

  @autobind
  _toggleCollapseTabs() {
    if (_.size(this.state.collapsed_tabs) == _.size(this.tabs)) {
      this.setState({
        collapsed_tabs: [],
      });
    } else {
      this.setState({
        collapsed_tabs: this.tabs,
      });
    }

    this.refs.scroll.scrollTop = 0;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.forceMeetingUpdate && this.props.forceMeetingUpdate) {
      setTableParams('plan_uploads', {
        forceMeetingUpdate: undefined,
      });

      this.props.readAction(this.props.data.id);
    }
  }

  render() {
    const { data, readAction } = this.props;

    const { collapsed_tabs, highlighted_tab } = this.state;

    const TabLink = ScrollLink((props) => (
      <span
        ref={(ref) => (this.tab_refs[props.target] = ref)}
        onClick={(e) => {
          this.setState({
            collapsed_tabs: _.reject(
              collapsed_tabs,
              (section) => section == props.target
            ),
          });

          props.target == 'history' && this._lazyLoadTaskHistory();

          this._highlightSection(props.target);

          props.onClick(e);
        }}
        className={props.className}
      >
        {props.children}
      </span>
    ));

    const Tab = (props) => (
      <TabLink
        target={props.target}
        activeClass={styles.active}
        to={props.target}
        spy={true}
        smooth={true}
        duration={500}
        container={this.refs.scroll}
      >
        {props.children}
      </TabLink>
    );

    return (
      <div className={styles.preview}>
        <div className={styles.header}>
          <div className={styles.title}>
            <span>
              {data.code && <strong>{data.code}: </strong>}
              {data.title}
            </span>
            <CloseBigIcon
              onClick={() =>
                setTimeout(() => {
                  setTableParams('plan_uploads', {
                    clicked_row: undefined,
                  });
                }, 100)
              }
            />
          </div>
          <div className={styles.actions}>
            {_.get(data, 'status') == '1' && !_.get(data, 'ocr_processing') && (
              <div className={styles.actionWrapper}>
                <Tooltip text={__('plans.tooltip.icon.plan-publish')}>
                  <SendIcon
                    onClick={() => {
                      if (_.isEmpty(data.code)) {
                        setNotification({
                          text: __('plans.uploads.notification.missing-number'),
                          type: 'warning',
                        });
                      } else if (data.existing == true) {
                        setNotification({
                          text: __(
                            'plans.uploads.notification.code-existing-disallow-publish'
                          ),
                          type: 'warning',
                        });
                      } else {
                        publishPlanUploads([data.id]).then(() => {
                          setNotification(
                            __('plans.uploads.notification.published')
                          );

                          listPlanUploads(this.props.match.params.stage);

                          setTableParams('plan_uploads', {
                            clicked_row: undefined,
                          });
                        });
                      }
                    }}
                  />
                </Tooltip>
              </div>
            )}
            {_.get(data, 'status') == '1' && !_.get(data, 'ocr_processing') && (
              <div className={styles.actionWrapper}>
                <Tooltip
                  text={__('plans.tooltip.icon.ocr-plan')}
                  key={_.uniqueId()}
                >
                  <OCRIcon
                    onClick={(e) => {
                      e.stopPropagation();

                      this.props.actions.setTableParams({
                        ocr_plans_wizard: [data.id],
                      });
                    }}
                  />
                </Tooltip>
              </div>
            )}
            <div className={styles.actionWrapper}>
              <Tooltip
                text={__('plans.plan-upload-list.flyout.delete-plan-upload')}
                key={_.uniqueId()}
              >
                <DeleteIcon
                  onClick={(e) => {
                    e.stopPropagation();

                    showAlertbox({
                      color: 'red',
                      title: __('general.alert.are-you-sure'),
                      description: __(
                        'plans.plan-upload-list.want-delete-selected-plan.this-process-cannot-undone'
                      ),
                      buttons: [
                        {
                          color: 'lightGray',
                          text: __('general.alert.no-close'),
                          onClick: 'close',
                        },
                        {
                          color: 'gray',
                          text: __('general.alert.yes-delete'),
                          onClick: () => {
                            deletePlanUploads([data.id]).then(() => {
                              hideAlertbox();

                              setNotification(
                                __(
                                  'plans.plan-upload-list.selected-plan-upload-deleted'
                                )
                              );
                              listPlanUploads(this.props.match.params.stage);

                              setTableParams('plan_uploads', {
                                clicked_row: undefined,
                              });
                            });
                          },
                        },
                      ],
                    });
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>

        <div className={styles.tabsWrapper}>
          <ArrowDownMiddleIcon
            className={classNames(
              styles.collapseAll,
              _.size(collapsed_tabs) == _.size(this.tabs) && styles.collapsed
            )}
            onClick={this._toggleCollapseTabs}
          />
          <div className={styles.tabs}>
            <Tab target='properties'>
              {__('plans.plan-uploads.tab.properties')}
            </Tab>
            <Tab target='files'>
              {__('plans.plan-uploads.tab.files')}{' '}
              {!_.isEmpty(data.files) && ' (' + _.size(data.files) + ')'}
            </Tab>
          </div>
        </div>

        <div className={styles.content} ref='scroll'>
          <Element
            name='properties'
            className={classNames(
              styles.section,
              highlighted_tab == 'properties' && styles.highlighted
            )}
          >
            <div
              className={styles.title}
              onClick={() => this._toggleCollapseTab('properties')}
            >
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.collapse,
                  _.includes(collapsed_tabs, 'properties') && styles.collapsed
                )}
              />
              {__('plans.plan-uploads.tab.properties')}
            </div>
            <Properties
              collapsed={_.includes(collapsed_tabs, 'properties')}
              data={data}
              readAction={readAction}
            />
          </Element>

          <Element
            name='files'
            className={classNames(
              styles.section,
              highlighted_tab == 'files' && styles.highlighted
            )}
          >
            <div
              className={styles.title}
              onClick={() => this._toggleCollapseTab('files')}
            >
              <ArrowDownMiddleIcon
                className={classNames(
                  styles.collapse,
                  _.includes(collapsed_tabs, 'files') && styles.collapsed
                )}
              />
              {__('plans.plan-uploads.tab.files')}
              {!_.isEmpty(data.files) && ' (' + _.size(data.files) + ')'}
            </div>
            <Files
              collapsed={_.includes(collapsed_tabs, 'files')}
              data={data}
              readAction={readAction}
            />
          </Element>
        </div>
      </div>
    );
  }
}

export default PlanUploadsFlyout;
